// --- GLOBAL VARIABLES --- //
var $window = $(window);
var $document = $(document);
var $header = $(".header");
var bp_xsmall = 576;
var bp_small = 771;
var bp_medium = 992;
var bp_large = 1200;
var class_active = "is-active";
var class_last = "is-last";
var class_disabled = "is-disabled";
var $this = null;
var $containers = $("html,body");

// --- COMPONENTS, PARTS --- //
$(document).ready(function() {
	// ---  COMPONENTS --- //
	fn_components_fullscreen_navigation();
	fn_components_gallery();
	fn_components_slider();
	fn_components_aos();
	
	// ---  PARTS --- //
	fn_parts_scroll_resize();
	fn_parts_scroll_to();
	fn_parts_count_thumbnail_item();
});


// --- SCROLL EVENT --- //
$(document).scroll(function() {
	fn_parts_scroll_resize();
});

// --- RESIZE EVENT --- //
$(window).resize(function() {
	fn_parts_scroll_resize();
	fn_parts_count_thumbnail_item();
});

// --- LOAD EVENT --- //
$(window).bind("load", function() {
	fn_parts_dots();
});

